import * as React from "react";
import IntakeStrategySidebar from "./IntakeStrategySidebar";
class IntakeStrategyHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    document.title = "TrinDocs - Intake Strategies";
  }
  componentWillUnmount() {
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container-fluid", style: { height: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "row flex-nowrap", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(IntakeStrategySidebar, { activePage: "bp" }), /* @__PURE__ */ React.createElement("div", { className: "h-100 d-flex align-items-center" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "p-2 col-example",
        style: {
          textAlign: "center",
          marginLeft: "100px",
          marginRight: "100px",
          width: "60%"
        }
      },
      /* @__PURE__ */ React.createElement("i", { className: "fa-duotone fa-solid fa-file-import", style: { fontSize: "54pt", "--fa-primary-color": "#215bc0", "--fa-secondary-color": "#215bc0", "--fa-secondary-opacity": "0.6" } }),
      /* @__PURE__ */ React.createElement("h2", { className: "mt-2", style: { fontWeight: "bolder", fontStyle: "italic" } }, "Intake Strategies")
    ))));
  }
}
export default IntakeStrategyHome;
